import React, { useEffect, useContext } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import LocalAudioLevelIndicator from './LocalAudioLevelIndicator/LocalAudioLevelIndicator';

import ToggleFullscreenButton from './ToggleFullScreenButton/ToggleFullScreenButton';
import Toolbar from '@material-ui/core/Toolbar';

import { useParams } from 'react-router-dom';
import useRoomState from '../../hooks/useRoomState/useRoomState';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import RecordingIndicator from './RecordingIndicator/RecordingIndicator';
import { MeetingContext } from '../../App';
import { ToolBarContext } from '../../App';
import ToastMessage from '../ToastMessage/ToastMessage';
import AlertDialog from './AlertDialog/AlertDialog';
import FlipCameraButton from './FlipCameraButton/FlipCameraButton';
import { axClient } from '../../axiosClient';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      backgroundColor: '#FFF',
    },
    logo: {
      height: '35px',
      width: 'auto',
    },
    toolbar: {
      [theme.breakpoints.down('xs')]: {
        padding: 0,
      },
    },
    leftButtonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginLeft: 'auto',
    },
    form: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
      width: 200,
    },
    loadingSpinner: {
      marginLeft: '1em',
    },
    displayName: {
      marginLeft: '2.2em',
      minWidth: '200px',
      fontWeight: 600,
    },
    joinButton: {
      margin: '1em',
    },
  })
);

export default function MenuBar() {
  const classes = useStyles();
  const { URLRoomName } = useParams();
  const {
    room: { localParticipant },
    isRecording,
    meetingEndedByHost,
  } = useVideoContext();
  const roomState = useRoomState();
  const { company, validLink } = useContext(MeetingContext);
  const { room } = useVideoContext();
  const { meetingEnded, setMeetingEnded } = useContext(ToolBarContext);

  useEffect(() => {
    if (meetingEndedByHost) {
      axClient.post('/event', {
        event_type: 'participant_left',
        event_data: { username: localParticipant.identity },
      });
      setMeetingEnded(true);
      room.disconnect();
    }
  }, [meetingEndedByHost]);

  return (
    <AppBar className={classes.container} position="static">
      <Toolbar className={classes.toolbar}>
        {roomState === 'disconnected' ? (
          <img
            src="https://zuper.co/wp-content/uploads/2020/01/logo_trans-1.png"
            className={classes.logo}
            alt="Zuper_logo"
          />
        ) : company.company_logo === undefined ? (
          <img
            src="https://zuper.co/wp-content/uploads/2020/01/logo_trans-1.png"
            className={classes.logo}
            alt="Zuper_logo"
          />
        ) : (
          <img src={company.company_logo} className={classes.logo} alt="Meeting_company_logo" />
        )}
        {!URLRoomName ||
          (validLink !== undefined && !validLink && (
            // Alert for Invalid Meeting
            <AlertDialog alertType="invalidMeeting" />
          ))}

        {!meetingEnded && (
          <div className={classes.leftButtonContainer}>
            {roomState === 'connected' && isRecording ? <RecordingIndicator /> : null}
            <FlipCameraButton />
            <LocalAudioLevelIndicator />
            <ToggleFullscreenButton />
            <ToastMessage />
          </div>
        )}
      </Toolbar>
    </AppBar>
  );
}
